<mat-dialog-content #scroll class="dialog-container">
  <form [formGroup]="form">
    <div class="row">
      <mat-form-field class="col-6">
        <mat-label>Name</mat-label>
        <input
          matInput
          [formControlName]="'name'"
          [placeholder]="'Role Name'"
          [required]="required"
          (keypress)="alphaNumericWithCharacters($event)"
        />
        <mat-error>This field is required</mat-error>
      </mat-form-field>
      <mat-form-field class="col-6">
        <mat-label>ID</mat-label>
        <input
          matInput
          [formControlName]="'id'"
          [placeholder]="'Role Id'"
          [required]="required"
          [readonly]="update"
          (keypress)="alphaNumericWithCharacters($event)"
        />
        <mat-error>This field is required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <div class="col-6 edit-rights">
        @if (!loading) {
          <mat-form-field class="col-12 p-0">
            <mat-label>Rights</mat-label>
            <mat-chip-grid
              #rightsList
              aria-label="rights"
              class="mat-mdc-chip-set-stacked"
            >
              @if (data.role && data.role.rights) {
                @for (right of data.role.rights; track right; let i = $index) {
                  <mat-chip-row
                    [removable]="'true'"
                    (removed)="removeAssignedRight(right)"
                  >
                    {{ selectedRightDisplay(right, true) }}

                    <span class="right-id">
                      ({{ selectedRightDisplay(right) }})
                    </span>
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
              }
              <input
                placeholder="Select Rights..."
                #rightsInput
                [formControl]="rightCtrl"
                [matAutocomplete]="autoRole"
                [matChipInputFor]="rightsList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="
                  addItem($event, data.rights, form['assignedRights'])
                "
                (click)="focusRights()"
              />
            </mat-chip-grid>
            <mat-autocomplete
              #autoRole="matAutocomplete"
              (optionSelected)="selectedRight($event)"
            >
              @for (right of filteredRights | async; track right.id) {
                <mat-option [value]="right.id">
                  {{ right.id }}
                  <span class="right-id">({{ right.name }})</span>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="w-100 buttons">
  @if (update) {
    <button mat-button color="warn" (click)="delete()">
      <mat-icon>delete</mat-icon> Delete
    </button>
  }
  <span>
    <button mat-stroked-button (click)="cancel()"
      ><mat-icon>close</mat-icon> Cancel</button
    >
    <button mat-raised-button color="accent" (click)="save()">
      <mat-icon>save</mat-icon> Save
    </button>
  </span>
</mat-dialog-actions>
